import DashboardLayout from '@/views/Layout/DashboardLayout.vue';

const FieldsList = () => import(/* webpackChunkName: "fields" */ '@/views/Fields/List.vue');
const FieldCreate = () => import(/* webpackChunkName: "fields" */ '@/views/Fields/Create.vue');
const FieldShow = () => import(/* webpackChunkName: "fields" */ '@/views/Fields/Show.vue');
const FieldEdit = () => import(/* webpackChunkName: "fields" */ '@/views/Fields/Edit.vue');

let fieldsPages = {
  path: '/fields',
  redirect: '/fields',
  component: DashboardLayout,
  name: 'Fields',
  meta: {
    title: 'Campos',
    auth: true,
  },
  children: [
    {
      path: '',
      name: 'FieldsList',
      meta: {
        title: 'Listado',
        auth: ['fields.index'],
      },
      component: FieldsList,
    },
    {
      path: 'create',
      name: 'FieldCreate',
      meta: {
        title: 'Nuevo',
        auth: ['fields.store'],
      },
      component: FieldCreate,
    },
    {
      path: ':id',
      name: 'FieldShow',
      meta: {
        title: 'Detalle',
        auth: ['fields.show'],
      },
      component: FieldShow,
    },
    {
      path: ':id/edit',
      name: 'FieldEdit',
      meta: {
        title: 'Editar',
        auth: ['fields.show'],
      },
      component: FieldEdit,
    },
  ],
};

export default fieldsPages;
